<script>
import axios from 'axios';
import { sortBy } from 'lodash';
import Utility from '@/common/UtilityFunctions';
import Questionnaire from '@/components/UI/QuestionnaireQQ.vue';
import { hasProperty } from '@/common/Util/utility';
import BaseMixin from '../BaseMixin.vue';

export default {
  components: {
    Questionnaire
  },
  emits: ['showStdErrorModal'],
  mixins: [BaseMixin],
  props: {
    ruleVerificationTextProp: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      ruleVerificationText: {
        type: String,
        default() {
          return '';
        }
      },
      config: {
        headers: {
          'Content-Type': 'application/json'
        }
      },
      apiResponseError: null
    };
  },
  computed: {
    policyQuestions() {
      if (
        this.vueModel.TemplateModel.PolicyQuestionnaire === undefined ||
        this.vueModel.TemplateModel.PolicyQuestionnaire === null
      ) {
        return [];
      }
      return sortBy(this.vueModel.TemplateModel.PolicyQuestionnaire.Questionnaires, 'SortOrder');
    },
    assetQuestions() {
      if (
        this.vueModel.TemplateModel.AssetQuestionnaire === undefined ||
        this.vueModel.TemplateModel.AssetQuestionnaire === null
      ) {
        return [];
      }
      return sortBy(this.vueModel.TemplateModel.AssetQuestionnaire.Questionnaires, 'SortOrder');
    },
    getDanishProductTypeName() {
      return Utility.getDanishTypeName(this.vueModel.ProductTypeName);
    }
  },
  mounted() {
    $(document).scrollTop(0);
    $('#additional-information').addClass('active');
    this.ruleVerificationText = this.ruleVerificationTextProp;
  },
  methods: {
    saveQuickQuoteData(callbackDone, callbackFail) {
      this.postQuickQuote(this.vueModel.ProductType, JSON.stringify(this.vueModel))
        .then((response) => {
          this.postSuccess(response, callbackDone);
        })
        .catch((err) => {
          // TODO: implement error handling
          this.setApiErrorData(err.response.data);
          if (callbackFail) {
            callbackFail();
          }
          Utility.pushToTagManager({
            event: 'track-event',
            eventCategory: this.getDanishProductTypeName + ' prisberegner',
            eventAction: '01 oplysninger error',
            eventLabel: err,
            eventValue: '0',
            eventNoninteraction: true
          });
        });
    },
    updateQuickQuoteAsset(callbackDone, callbackFail) {
      this.postQuickQuoteAsset(this.vueModel.ProductType, JSON.stringify(this.vueModel))
        .then((response) => {
          this.postSuccess(response, callbackDone);
        })
        .catch((err) => {
          this.setApiErrorData(err.response.data);
          if (callbackFail) {
            callbackFail();
          }
        });
    },
    postQuickQuoteAsset(type, data) {
      return axios.post(
        Utility.constants().API.quick_quote_flow_save + type + '/asset/update',
        data,
        this.config
      );
    },
    postQuickQuote(type, data) {
      return axios.post(
        Utility.constants().API.quick_quote_flow_save + type + '/save',
        data,
        this.config
      );
    },
    handleResponse(response, callbackValidationError, gotoNext = true, errorHandeling = undefined) {
      if (response) {
        this.vueModel.TemplateModel.ValidationErrors = response.ValidationErrors;
        this.vueModel.TemplateModel.Asset = response.Asset;
        if (response.Coverage) {
          this.setCovers(response.Coverage);
        }
        if (response.IsPriceIndicative) {
          this.setIndicativePriceText(response.IsPriceIndicative);
        }

        // Check for logical errors first, we can't trust rules otherwise
        var validationError = false;
        if (
          hasProperty(this.vueModel.TemplateModel, 'ValidationErrors') &&
          this.vueModel.TemplateModel.ValidationErrors.length > 0
        ) {
          validationError = true;
        }

        // If no logical errors from IDIT arrises, then check our own rules
        if (
          !validationError &&
          hasProperty(response, 'ProductRuleVerificationErrors') &&
          response.ProductRuleVerificationErrors !== null
        ) {
          this.updateActiveVerificationIssues(response.ProductRuleVerificationErrors);
          gotoNext = !this.verifyBlockingRules();
        }

        if (validationError) {
          callbackValidationError();
        } else if (gotoNext) {
          this.goToCovers();
        }
      } else {
        if (errorHandeling) {
          errorHandeling();
        }
      }
    },
    postSuccess(response, callbackDone) {
      const responseJSON = response.data;
      if (responseJSON.Covers) {
        this.updateCovers(responseJSON.Covers);
      }
      callbackDone(responseJSON);
    },
    showErrorModal(err) {
      this.$parent.$parent.$parent.showQuickQuoteModalErrorValidation = false;
      this.$parent.$parent.$parent.showQuickQuoteModal = true;
      if (err) {
        Utility.logError(err.message, this);
      }
    },
    disableTimeUTCConversion() {
      Date.prototype.toJSON = function () {
        const hoursDiff = this.getHours() - this.getTimezoneOffset() / 60;
        this.setHours(hoursDiff);
        return this.toISOString();
      };
    },
    enableTimeUTCConversion() {
      delete Date.prototype.toJSON;
    },
    setApiErrorData(data) {
      this.apiResponseError = data;
    }
  }
};
</script>
